import { create } from 'zustand';
import { InvoicesDataStoreType } from '@am3nd-org/pointcraft-types';

import { mockInvoiceList, mockInvoiceOverviews } from './mockData';

export const useInvoiceListStore = create<InvoicesDataStoreType>((set, _get) => ({
  outstanding: mockInvoiceOverviews.outstanding,
  overdue: mockInvoiceOverviews.overdue,
  unpaid: mockInvoiceOverviews.unpaid,
  partial: mockInvoiceOverviews.partial,
  paid: mockInvoiceOverviews.paid,
  invoiceList: mockInvoiceList,

  // invoiceList: [], // Set all to empty arrays
  setOverviews: ({ outstanding, overdue, unpaid, partial, paid }) => {
    set((state) => ({
      ...state,
      outstanding: outstanding ?? state.outstanding,
      overdue: overdue ?? state.overdue,
      unpaid: unpaid ?? state.unpaid,
      partial: partial ?? state.partial,
      paid: paid ?? state.paid,
    }));
  },
  addInvoice: (invoice) => {
    set((state) => ({ ...state, invoiceList: [...state.invoiceList, invoice] }));
  },
  updateInvoice: (invoice) => {
    set((state) => ({
      ...state,
      invoiceList: state.invoiceList.map((inv) => (inv.id === invoice.id ? invoice : inv)),
    }));
  },
  setInvoiceList: (invoiceList) => {
    set((state) => ({ ...state, invoiceList }));
  },
}));

/**
 *

  const { example, exampleVar: false } = useInvoiceListStore((state) => ({
    currentInventory: state.currentInventory,
    newInventory: state.newInventory,
  }));

  const setExample = useExampleDataStore.getState().setExample();

 */
